import React, { useEffect, useState, useMemo } from 'react';
import { Trans, useTranslation } from "react-i18next";
import {
  Space,
  Button,
  Collapse,
  Drawer,
  Radio,
} from '@lockerpm/design';

import {
} from '@ant-design/icons';

function FormData(props) {
  const {
    visible = false,
    onClose = () => {},
  } = props
  const { t } = useTranslation()

  const [step, setStep] = useState(0)
  const [scanIn, setScanIn] = useState('local_project')
  const [activeKeys, setActiveKeys] = useState(['step3'])

  useEffect(() => {
    setStep(0)
  }, [
    visible
  ])

  const steps = useMemo(() => {
    return [
      {
        key: 'step1',
        active: activeKeys.includes('step1'),
        content: <div>
          <ul className='pl-4 flex flex-col'>
            <li className='text-primary'>
              <a
                className='text-primary font-semibold underline'
                // target='_blank'
              >
                {t('leaked_secrets.form_data.steps.step1.content.window')}
              </a>
            </li>
            <li className='text-primary'>
              <a
                className='text-primary font-semibold underline'
                // target='_blank'
              >
                {t('leaked_secrets.form_data.steps.step1.content.linux')}
              </a>
            </li>
            <li className='text-primary'>
              <a
                className='text-primary font-semibold underline'
                // target='_blank'
              >
                {t('leaked_secrets.form_data.steps.step1.content.mac_arm64')}
              </a>
            </li>
            <li className='text-primary'>
              <a
                className='text-primary font-semibold underline'
                // target='_blank'
              >
                {t('leaked_secrets.form_data.steps.step1.content.mac64')}
              </a>
            </li>
          </ul>
        </div>
      },
      {
        key: 'step2',
        active: activeKeys.includes('step2'),
        content: <div
          className="px-4 py-2 border border-solid border-black-300 rounded-md code-box w-full"
        >
          {`locker configuration --access-key-id {id} --secret-access-key {secret key}`}
        </div>
      },
      {
        key: 'step3',
        active: activeKeys.includes('step3'),
        content: <div>
          <Radio.Group
            value={scanIn}
            onChange={(e) => setScanIn(e.target.value)}
          >
            <Space direction="vertical">
              <Radio value={'local_project'}>
                {t('leaked_secrets.form_data.steps.step3.content.local_project')}
              </Radio>
              <Radio value={'public_git_repo'}>
                {t('leaked_secrets.form_data.steps.step3.content.public_git_repo')}
              </Radio>
              <Radio value={'private_git_repo'}>
                {t('leaked_secrets.form_data.steps.step3.content.private_git_repo')}
              </Radio>
            </Space>
          </Radio.Group>
        </div>
      }
    ]
  }, [scanIn, activeKeys]);

  useEffect(() => {
  }, [visible])

  const changeStepCollapse = (key) => {
    if (activeKeys.includes(key)) {
      setActiveKeys(activeKeys.filter((k) => k !== key))
    } else {
      setActiveKeys([...activeKeys, key])
    }
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('leaked_secrets.form_data.title')}
        placement="right"
        onClose={onClose}
        open={visible}
        width={424}
        footer={
          <Space className='flex items-center justify-end'>
            {
              step === 0 && <>
                <Button
                  onClick={onClose}
                >
                  {t('button.cancel')}
                </Button>
                <Button
                  type="primary"
                  onClick={() => setStep(1)}
                >
                  {t('button.next')} 
                </Button>
              </>
            }
            {
              step === 1 && <>
                <Button
                  onClick={() => setStep(0)}
                >
                  {t('button.back')}
                </Button>
                <Button
                  type="primary"
                  onClick={onClose}
                >
                  {t('button.done')} 
                </Button>
              </>
            }
          </Space>
        }
      >
        {
          step === 0 && <div className='flex flex-col gap-4'>
            <p className='font-semibold'>{t('leaked_secrets.form_data.description')}</p>
            <div className='flex flex-col gap-2'>
              {
                steps.map((s, index) => <div
                  className='rounded-xl border border-solid border-black-300'
                  key={index}
                >
                  <Collapse
                    className='step-collapse'
                    activeKey={s.active ? ['1'] : []}
                    ghost
                    expandIconPosition="end"
                    onChange={() => changeStepCollapse(s.key)}
                  >
                    <Collapse.Panel
                      header={
                        <p
                          className='font-semibold'
                        >
                          {index + 1}. {t(`leaked_secrets.form_data.steps.${s.key}.title`)}
                        </p>
                      }
                      key="1"
                    >
                      {s.content}
                    </Collapse.Panel>
                  </Collapse>
                </div>)
              }
            </div>
          </div>
        }
        {
          step === 1 && scanIn === "local_project" && <div className='flex flex-col gap-6'>
            <p className='font-semibold'>{t('leaked_secrets.form_data.steps.step3.scan_in_local_project.title')}</p>
            <div className='flex flex-col gap-3'>
              <p>
                {t('leaked_secrets.form_data.steps.step3.scan_in_local_project.description')}
              </p>
              <div
                className="px-4 py-2 border border-solid border-black-300 rounded-md code-box w-full"
              >
                {`scan --fix --language {targeted language} --source {local directory path}`}
              </div>
            </div>
            <div className='p-3 rounded-xl border border-solid border-black-300 flex flex-col gap-2'>
              <p>
                {t('leaked_secrets.form_data.steps.step3.scan_in_local_project.note1')}
              </p>
              <p>
                <Trans
                  i18nKey={'leaked_secrets.form_data.steps.step3.scan_in_local_project.note2'}
                  components={{
                    a: <a href='/' target='_blank' className='underline text-blue'/>,
                    b: <b className='font-semibold'/>
                  }}
                />
              </p>
            </div>
          </div>
        }
        {
          step === 1 && scanIn !== "local_project" && <div className='flex flex-col gap-6'>
            <p className='font-semibold'>{t('leaked_secrets.form_data.steps.step3.scan_in_public_git_repo.title')}</p>
            <div className='flex flex-col gap-3'>
              <p>
                {t('leaked_secrets.form_data.steps.step3.scan_in_public_git_repo.description')}
              </p>
              <div
                className="px-4 py-2 border border-solid border-black-300 rounded-md code-box w-full"
              >
                {`{binary} scan --remote --source {project url}`}
              </div>
              <p>
                <Trans
                  i18nKey={'leaked_secrets.form_data.steps.step3.scan_in_public_git_repo.note'}
                  components={{
                    a: <a href='/' target='_blank' className='underline text-blue'/>,
                  }}
                />
              </p>
            </div>
            <div className='p-3 rounded-xl border border-solid border-black-300 flex flex-col gap-3'>
              <p className='font-semibold'>
                {t('leaked_secrets.form_data.steps.step3.scan_in_public_git_repo.result.title')}
              </p>
              <p className='font-semibold'>
                {t('leaked_secrets.form_data.steps.step3.scan_in_public_git_repo.result.step1')}
              </p>
              <p>
                <Trans
                  i18nKey={'leaked_secrets.form_data.steps.step3.scan_in_public_git_repo.result.step2'}
                  components={{
                    a: <a href='/' target='_blank' className='underline text-blue'/>,
                  }}
                />
              </p>
            </div>
          </div>
        }
      </Drawer>
    </div>
  );
}

export default FormData;
